/* eslint-disable */
import Vue from 'vue';
// import BasicMiddleware from '@fund/mp-middleware-basic';
// import FeedbackMiddleware from '@fund/mp-middleware-feedback';
// eslint-disable-next-line import/no-unresolved
// import RouterMiddleware from '@fund/mp-middleware-router';
// import VueLazyload from './utils/lazyComponent';
// import App from './App.vue';
//import store from './store';
import * as filters from './filters/index';
// import ApiMoudle from './apis';
// import * as Sentry from '@sentry/browser';
import trackConfig from './configs/track';
import trackEncodeConfig from './configs/track-encode';
///////////////////////////////
//  import * as Sentry from '@sentry/browser';
import * as fundDebug from '@fund-debug/javascript';
import fundDebugVue from '@fund-debug/vue';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { getUrlParams } from '@fund/basic-lib/dist/lib/qs';

 if(navigator && navigator.userAgent && Object.prototype.toString.call(navigator.userAgent) === '[object String]' && navigator.userAgent.indexOf('UCBrowser') >= 0) {
  // uc 不上报了
} else {
  fundDebug.init({
    apikey: '5ea4338925f0f20bd95265d2750eb530',
  });
  fundDebugVue(fundDebug, Vue);
}


//////////


window.trackLogTime = new Date().getTime();
window.trackAllLog = [];
const trackNameList = [];
window.trackLog = function(title, ...params) {
  const now = new Date().getTime();
  const during = now - trackLogTime;
  console.warn('[track-log]', title, ...params, `${during}ms`);
  window.trackLogTime = now;

  const name = JSON.stringify(title).replace(/"/g,'');
  const index = trackConfig.indexOf(name)
  trackNameList.push(name);
  window.trackAllLog.push([index,during].join('|'));
};
window.trackSend = function() {
  try{
    let str = `tlv3:${window.trackAllLog.join()}`;
    trackEncodeConfig.map(cfg=>{
      str = str.replace(new RegExp(cfg[0],'g'), cfg[1]);
    });
    // .Sentry.captureMessage(str);
    // trackEncodeConfig.map(cfg=>{
    //   str = str.replace(new RegExp(cfg[1],'g'), cfg[0]).replace(/\\/g,'');
    // });
  }catch(err){
    console.error(err)
  }
}


// trackLog('开始');
// 生成一个 14 位的随机数
function generateRandomUVNO() {
  return Math.floor(10000000000000 + Math.random() * 90000000000000).toString();
}
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

// 设置 Cookie
function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

// 获取 uvno
function getUVNO() {
  let uvno = getCookie('wx-uvno');
  if (!uvno) {
      uvno = generateRandomUVNO();
      setCookie('wx-uvno', uvno, 30); // 设置 Cookie 有效期为 30 天
  }
  return uvno;
}
function objectToQueryString(data, prefix = '') {
  const pairs = [];

  for (const key in data) {
      if (data.hasOwnProperty(key)) {
          const value = data[key];
          const encodedKey = prefix ? `${prefix}[${encodeURIComponent(key)}]` : encodeURIComponent(key);

          if (typeof value === 'object' && value !== null) {
              // 如果值是对象，使用 JSON.stringify
              pairs.push(`${encodedKey}=${encodeURIComponent(JSON.stringify(value))}`);
          } else {
              // 处理基本类型
              pairs.push(`${encodedKey}=${encodeURIComponent(value)}`);
          }
      }
  }

  return pairs.join('&');
}
function init() {
  console.log('main init');

  // trackLog('初始化');
  var BasicMiddleware = require('@fund/mp-middleware-basic');
  var FeedbackMiddleware  = require( '@fund/mp-middleware-feedback');
  var RouterMiddleware  = require( '@fund/mp-middleware-router');
  var VueLazyload  = require( './utils/lazyComponent').default;
  var App  = require( './DetailPage.vue').default;
  var store  = require( './store').default;
  // var * as filters from './filters/index';
  var ApiMoudle = require('./apis').default;
  var reportMonitor = require( '@fund/basic-lib/dist/lib/monitor/reportMonitor').default;

  var Multi = require( '@fund/multi');
////////////////////////////////
  window.multi = Multi(Vue);
  var fundCode = getUrlParams()?.fCode?.toString();
  var webPlatf = window.multi.$system.webPlatform;
  var wxTrackInfo = getUrlParams()?.wxTrackInfo?.toString()
  var uvno = getUVNO()
  var trackingImg = null;
  console.log('---> fundCode', fundCode,wxTrackInfo,webPlatf);
///////////////////////////////////
//////////////////////
///////////

  Vue.use(VueLazyload);

  Vue.config.productionTip = false;
  Vue.use(BasicMiddleware);
  Vue.use(FeedbackMiddleware);
  Vue.use(RouterMiddleware);
  // 添加全局过滤器
  Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
  });
  Vue.prototype.$http = ApiMoudle;
  // eslint-disable-next-line no-param-reassign
  Vue.prototype.reportMonitor = reportMonitor;
  Vue.prototype.trackLog = window.trackLog;
  Vue.prototype.trackSend = window.trackSend;
  Vue.prototype.$isEmpty = isEmpty;
  Vue.prototype.$goFundApp = function() {
    if(webPlatf === 'wxmp') {
      wx.miniProgram.navigateTo({
        url: '/pages/download/index' // 下载中间页
      });
      return;
    }
    try {
      window.multi.$router.push({
        type: 1,
        url: `fund://page/funddetail?fundcode=${fundCode}&id=${fundCode}`
      })
    } catch(err) {
      console.log('goFundApp ERR', err);
    }
  }
  Vue.prototype.$wxSendTrack = function(eventName,eventType,extend){
    if(webPlatf !== 'wxmp'||!wxTrackInfo) return
    const [brand,model,system,version,userId,uid,openid,unionid,sessionId,sessionLogTime] = wxTrackInfo.split(/_/g)||[]
    const trackObj = {
      EventType: eventType,
          EventCode:`wx.${eventName}`,
          url:`https://h5.1234567.com.cn/app/fund-details/?fCode=${fundCode}`,
          //url:path,
          elem:'DIV',
          appKey:'8t5j9w29',
          deviceBrand:brand,
          phoneModle:model,
          //osVersion:system,
          UVNO:uvno,

          phoneAppVersion:version,
          logtime:new Date().toISOString(),
          appSeid:sessionId,
          ExtInfo:{...extend,openid,
            path:`/pages/fund-detail/index`,
            unionid,},
          tradeIDType: userId ? '2' : '0',
          tradeID:uid,
          UID:userId,

    }
    const queryString = objectToQueryString(trackObj);
    const url = 'https://bdwblog.eastmoney.com/bd-blink-server/asyncgapi/Web_Event.gif'
    // 构建完整的 URL
    const fullUrl = queryString ? `${url}?${queryString}` : url;
    if (!trackingImg) {
      trackingImg = document.createElement('img');
      trackingImg.style.display = 'none'; // 设置为不可见
      document.body.appendChild(trackingImg); // 将 img 添加到文档中
  }
     trackingImg.src = fullUrl;
  //   fetch(fullUrl, {
  //     method: 'GET',
  //     headers: {
  //         'Content-Type': 'application/json', // 根据需要设置请求头
  //     },
  // })
  }



  new Vue({
    store,
    render(h) {
      return h(App);
    },
  }).$mount('#app');
}

if (typeof fund === 'object') {
  init();
} else {
  window.addEventListener('fundJSBridgeReady', () => {
    init();
  });
////////////////////////////////
  init();
///////////////////////////////////
///////////
}
